export default __webpack_public_path__ + "static/button-label-dont-light-6e241562960ef962439934b6f9b12560afbfeedec6c13bb937a36c4998bfbc77.png";